import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss'
import Vant from 'vant';
import { Locale } from 'vant';
import viVN from 'vant/es/locale/lang/vi-VN';
import enUS from 'vant/es/locale/lang/en-US';
import 'vant/lib/index.css';
import VueI18n from 'vue-i18n'
import axios from 'axios';


// swiper
import VueClipboard from 'vue-clipboard2';
// import style
//main.js
import 'swiper/css/swiper.min.css'
import 'swiper/js/swiper.min'

import VueLazyload from "vue-lazyload";
import "./assets/fonts/iconfont.css";
import "./assets/css/css.css";
import locale from 'element-ui/lib/locale/lang/en'

// import javascript
import mine from '@/common/common.js';
import helper from '@/common/helper.js';
import request from '@/utils/request.js';
import updateSystem from '@/common/updateSystem.js';
axios.defaults.baseURL = helper.getApiUrl();
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$https = axios;
Vue.prototype.$helper = helper;
Vue.mixin(mine);
Vue.use(VueI18n);
Vue.use(ElementUI,{locale});
Vue.use(VueClipboard);
Vue.use(request);
Vue.use(Vant);


var load = async function() {
	var i18n_messages = helper.get('i18n_messages');
	var i18n_lang = helper.getLang();
	if(i18n_lang == 'vn'){
		Locale.use('vi-VN', viVN);
	}else if(i18n_lang == 'us'){
		Locale.use('en-US', enUS);
	}
	const i18n = new VueI18n({
		locale: i18n_lang ? i18n_lang : 'cn', // 设置语言环境
		fallbackLocale: i18n_lang ? i18n_lang : 'cn', // 设置语言环境
		silentTranslationWarn: true,
		messages:i18n_messages// 设置语言环境信息
	})
	if(!i18n_messages) await updateSystem({i18n})
	new Vue({ router , store , i18n , render: h => h(App) }).$mount('#app')
	if(i18n_messages) await updateSystem({i18n})
	
	
	
	var timestamp = new Date().getTime();
	if (!helper.get('uuid')) {
		helper.set('uuid', timestamp); // 仅在未设置时才设置
	}
	

}




load().then(() => {

});